module.exports = __webpack_public_path__ + "img/GH-kyujin-top-040.989d64a2.webp";